(async function boot() {
  const log = (msg: string) => {
    // console.log(`[BOOT] ${msg}`);
  };

  // Expose to window for other modules
  (window as any).__BOOT_LOG = log;

  // 🕵️µï¸ Deep Error Tracking
  window.addEventListener('error', (e) => {
    // @ts-ignore
    if (e.target && e.target.src) console.log(`SRC: ${e.target.src}`);

    if (e.message === 'Script error.') {
      console.warn('iOS: Cross-origin script error. Possible CORS or Evaluation crash.');
      if (e.target && (e.target as any).src && (e.target as any).src.includes('auth/iframe')) {
        console.warn('CRITICAL: Firebase Auth iframe blocked/failed!');
      }
    }
  }, true); // Use capture phase to see script tag failures

  window.addEventListener('unhandledrejection', (e) => {
    // @ts-ignore
    const reason = e.reason;
    log(`PROMISE REJECTION: ${String(reason)}`);
    // @ts-ignore
    if (reason?.stack) log(`STACK: ${String(reason.stack).substring(0, 100)}...`);
  });

  // Helpful env visibility
  // @ts-ignore
  log(`ENV: mode=${import.meta.env.MODE} dev=${import.meta.env.DEV}`);

  // NETWORK DIAGNOSTIC
  log('DIAG: Testing connectivity...');

  // Storage Check
  try {
    const { SafeStorage } = await import('./utils/safeStorage');
    SafeStorage.setItem('boot_test', '1');
    SafeStorage.removeItem('boot_test');
    log('DIAG: SafeStorage available');
  } catch (e) {
    log('CRITICAL: SafeStorage BLOCKED/FAIL');
  }
  fetch('https://www.google.com/favicon.ico', { mode: 'no-cors' })
    .then(() => log('DIAG: Network OK (google success)'))
    .catch(e => log(`DIAG: Network FAIL (google): ${e.message}`));

  fetch('https://identitytoolkit.googleapis.com/v1/accounts:createAuthUri', { method: 'POST', body: '{}' })
    .then(() => log('DIAG: IdentityToolkit reachable'))
    .catch(e => log(`DIAG: IdentityToolkit FAIL: ${e.message}`));

})();
